// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"0":"696f850dc12734b4","338":"9d9d711cf7672dec","453":"cfc8a89debae3465","609":"cb8dba965500a230","686":"5fd61ee027f0974e","852":"7cbc26af23d4998d","946":"a9d655ac38023367"}[chunkId] + ".js";
};